<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row align="center">
      <v-card class="fornecedor-selector-card">
        <v-row>
          <v-col cols="12" md="6"
            ><v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="selector-list-title">Fornecedores dispon&iacute;veis</div>
            <v-data-table
              :headers="headers"
              :items="filteredList"
              class="elevation-1 fornecedor-data-table"
              :loading="loading"
              :mobile-breakpoint="768"
              loading-text="Buscando dados..."
              :footer-props="{
                showFirstLastPage: true,
                itemsPerPageText: 'Items por página',
                itemsPerPageOptions: [10, 25, 50],
              }"
            >
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      @click="addFornecedor(item)"
                      :disabled="atingiuLimiteFornecedores || fornecedorSelecionadoIdsSet.has(item.id)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        color="green"
                        v-if="!atingiuLimiteFornecedores"
                        >mdi-plus</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Adicionar fornecedor</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      @click="$emit('editar-fornecedor', item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="info">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar fornecedor</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12" md="6">
            <div class="selector-list-title">Fornecedores adicionados</div>
            <v-data-table
              :headers="headers"
              :items="fornecedorL"
              class="elevation-1 fornecedor-data-table"
              :loading="loading"
              :mobile-breakpoint="768"
              loading-text="Buscando dados..."
              :footer-props="{
                showFirstLastPage: true,
                itemsPerPageText: 'Items por página',
                itemsPerPageOptions: [5, 10],
              }"
            >
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      @click="removerFornecedor(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover fornecedor</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "produto",
  data: () => ({
    search: "",
    valid: true,
    errorMessage: false,
    headers: [
      { text: "", value: "actions", sortable: false },
      { text: "FORNECEDOR", value: "nome" },
      { text: "CONTATO", value: "contato" },
      { text: "EMAIL", value: "email" },
      { text: "TELEFONE", value: "telefone" },
    ],
  }),
  props: {
    fornecedorL: Array,
    showModal: Boolean,
  },
  computed: {
    ...mapState("fornecedor", ["fornecedores"]),
    fornecedoresSelecionados() {
      return this.fornecedorL || [];
    },
    fornecedorSelecionadoIdsSet() {
      return new Set(
        this.fornecedoresSelecionados.map((fornecedor) => fornecedor.idFornecedor)
      );
    },
    atingiuLimiteFornecedores() {
      return this.fornecedoresSelecionados.length >= 5;
    },
    termoPesquisaNormalizado() {
      return (this.search || "").toString().trim().toLowerCase();
    },
    filteredList() {
      const termo = this.termoPesquisaNormalizado;
      const selecionados = this.fornecedorSelecionadoIdsSet;

      return this.fornecedores.filter((f) => {
        if (f.ativo !== true || selecionados.has(f.id)) {
          return false;
        }

        if (!termo) {
          return true;
        }

        const id = f.id == null ? "" : f.id.toString().toLowerCase();
        const nome = (f.nome || "").toLowerCase();

        return id.includes(termo) || nome.includes(termo);
      });
    },
    loading() {
      return !(this.fornecedores != null && this.fornecedores.length > 0);
    },
  },
  methods: {
    updateObjectEstate() {
      return this.$refs.form.validate();
    },

    clear() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },

    addFornecedor: function (f) {
      if (this.atingiuLimiteFornecedores) {
        return;
      }

      if (this.fornecedorSelecionadoIdsSet.has(f.id)) {
        return;
      }

      var fornecedor = {};
      fornecedor.acrescimo = 0;
      fornecedor.descontoTotal = 0;
      fornecedor.subtotal = 0;
      fornecedor.idFornecedor = f.id;
      fornecedor.coleta = false;
      fornecedor.enderecoColeta = null;
      fornecedor.endereco = f.endereco + ', ' + f.numero + ' Bairro: ' + f.bairro + '. Cidade: ' + f.cidade + '/' + f.uf +  ' CEP:' + f.cep;
      fornecedor.idCondicaoPagamento = null;
      fornecedor.idLocalEntrega = null;
      fornecedor.nomeOrcamento = "";
      fornecedor.nome = f.nome;
      fornecedor.emails = f.emails;
      fornecedor.contato = f.contato;
      fornecedor.telefone = f.telefone;
      fornecedor.index =
        this.fornecedorL.length === 0
          ? 0
          : this.fornecedorL[this.fornecedorL.length - 1].index + 1;

      this.fornecedorL.push(fornecedor);
    },
    removerFornecedor(f) {
      const index = this.fornecedorL.findIndex(
        (fornecedor) => fornecedor.idFornecedor === f.idFornecedor
      );

      if (index >= 0) {
        this.fornecedorL.splice(index, 1);
      }
    },
    editFornecedor() {
      //this.$emit('abrirEdicaoFornecedor', item);
    },
  },
};
</script>

<style scoped>
.selector-list-title {
  color: #263238;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.3;
  margin: 0 0 8px;
}

.fornecedor-selector-card {
  width: 100%;
}

@media (max-width: 768px) {
  .fornecedor-selector-card {
    box-shadow: none;
  }
}
@media (max-width: 768px) {
  .fornecedor-selector-card,
  .fornecedor-data-table,
  .fornecedor-data-table ::v-deep .v-data-table__wrapper {
    max-width: 100%;
    overflow-x: hidden;
  }

  .fornecedor-data-table ::v-deep table,
  .fornecedor-data-table ::v-deep tbody,
  .fornecedor-data-table ::v-deep tr,
  .fornecedor-data-table ::v-deep td {
    max-width: 100%;
  }

  .fornecedor-data-table ::v-deep .v-data-table__mobile-row {
    align-items: flex-start;
    min-height: auto;
    padding: 8px 0;
  }

  .fornecedor-data-table ::v-deep .v-data-table__mobile-row__cell {
    max-width: 100%;
    text-align: right;
    overflow-wrap: anywhere;
    white-space: normal;
  }
}
</style>
